<template>
  <!-- <v-avatar
      image="//loremflickr.com/40/40/kitten"
      size="28"
    /> -->
  <v-card>
    <v-card-title>Account bearbeiten</v-card-title>
    <v-card-text>
      <v-row>
        <v-col
          ><v-text-field
            v-model="first_name"
            label="Vorname"
            style="margin-bottom: 10px"
        /></v-col>
        <v-col>
          <v-text-field
            v-model="last_name"
            label="Nachname"
            style="margin-bottom: 10px" />
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <DeleteWithConfirmationButton
        message="delete-user"
        class="mr-5"
        :deleteAction="authStore.deleteAccount" />

      <v-btn @click="changeName">Speichern</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script setup lang="ts">
import { onMounted, ref } from "vue";
import DeleteWithConfirmationButton from "../tools/DeleteWithConfirmationButton.vue";
import { useAuthStore } from "@/stores/authStore";
import { useSnackbar } from "vuetify-use-dialog";
import { useTranslation } from "i18next-vue";

const { t } = useTranslation();
const createSnackbar = useSnackbar();

const emit = defineEmits(["close"]);

const authStore = useAuthStore();

const first_name = ref("");
const last_name = ref("");

onMounted(() => {
  first_name.value = authStore.user.first_name;
  last_name.value = authStore.user.last_name;
});

function changeName() {
  authStore.changeUserName(first_name.value, last_name.value);
  createSnackbar({
    text: t("actions.success.name"),
    showCloseButton: false,
    snackbarProps: { color: "success", timeout: 1000 }
  });
  emit("close");
}
</script>

<style scoped>
.v-avatar {
  margin-right: 10px;
}
</style>
